import { SQStep } from '@belong/types';

/**
 * Call with the value of the `step` query param. Returns a `SQStep` enum.
 * Will return `ADDRESS_LOOKUP` by default if no step is provided.
 * Will return `INVALID` if there is no matching step defined.
 */
export const stepQueryToEnum = (stepInput: string | string[] | null): SQStep => {
  if (stepInput == null) {
    return SQStep.ADDRESS_LOOKUP;
  }

  const stepQuery = Array.isArray(stepInput) ? stepInput[0] : stepInput;
  const step = Object.values(SQStep).find(value => value === stepQuery);
  return step ?? SQStep.INVALID;
};

/**
 * Call with a `SQStep` enum. Returns new value of the `step` query param.
 * Will return `null` when given the default step `ADDRESS_LOOKUP`.
 */
export const stepEnumToQuery = (step: SQStep): string | null => {
  if (step === SQStep.ADDRESS_LOOKUP) {
    return null;
  }

  return step;
};

export const STEP_ONE_KEY = SQStep.ADDRESS_LOOKUP;
